import { useEffect } from 'react';

/** Calls handler when a click/touch occurs outside the referenced element. */
export const useClickOutside = (ref, handler, active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, active]);
};

export default useClickOutside;
